import { GatsbyImage } from 'gatsby-plugin-image';
import styled, { css } from 'styled-components';

import { media } from '@bitcoin-portal/verse-web-components/dist/themes/breakpoints';

export const Section = styled.div`
  display: grid;
  position: relative;
`;

export const Image = styled(GatsbyImage)<{
  $isConnected: boolean;
}>`
  ${({ $isConnected }) => css`
    grid-area: 1/1;
    height: auto;
    box-sizing: border-box;
    width: 100%;
    min-height: 186px;
    margin: auto;
    padding: 20px;
    filter: ${$isConnected ? 'unset' : 'blur(17px)'};

    &::after {
      content: '';
      position: absolute;
      top: 0;
      right: 0;
      background: linear-gradient(0deg, #030c14 0%, rgba(3, 12, 20, 0) 27.29%),
        radial-gradient(
          95.87% 46.83% at 50% 92.96%,
          #030c14 36.98%,
          rgba(0, 0, 0, 0) 100%
        );
    }

    ${media.sm`
      min-height: ${$isConnected ? '568px' : '158px'};
    `}
  `}
`;
